import { DefaultCellRenderer } from '@dealstack/frontend/shared/components/Table/Table/Table';
import { CellRendererProps, TData } from '@dealstack/frontend/shared/components/Table/Table/types';
import { ReactNode } from 'react';

export const CellRenderer = <T extends TData>(props: CellRendererProps<T>): JSX.Element => {
	if (props.column.id.startsWith('contracts-')) {
		return (
			<div className="pl-6 pr-4 w-full" style={props.style}>
				{props.cellValueFn(props.column, props.item) as ReactNode}
			</div>
		);
	} else {
		return <DefaultCellRenderer {...props} className="px-4" />;
	}
};
